




























import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import * as RouteNames from "@/employee/route-names";
import { formatCurrency } from "@/shared/currency";

@Component({
  components: {}
})
export default class SweepCallToAction extends Vue {
  formatCurrency = formatCurrency;

  @Prop({required: true})
  sweepIsActive: boolean;

  @Prop({required: true})
  sweepThreshold: number;

  @Prop({required: false})
  useV2: boolean;

  @Prop({ default: false })
  accountId: number;

  get sweepRoute () {
    if (this.useV2) {
      return RouteNames.DrivewealthSweepV2;
    }

    return RouteNames.DrivewealthSweep;
  }
}
